// extracted by mini-css-extract-plugin
export var titleContainer = "HeadingContent-module--titleContainer--2TgOd";
export var inview = "HeadingContent-module--inview--145x7";
export var title = "HeadingContent-module--title--1Q9sK";
export var contentContainer = "HeadingContent-module--contentContainer--11LHV";
export var content = "HeadingContent-module--content--3CpjW";
export var buttonContainer = "HeadingContent-module--buttonContainer--1IUPA";
export var show = "HeadingContent-module--show--3hzvN";
export var showFadeInDown = "HeadingContent-module--show-fade-in-down--1Tfrn";
export var showFadeInUp = "HeadingContent-module--show-fade-in-up--2BMzj";
export var hideFadeOut = "HeadingContent-module--hide-fade-out--3TXXy";